export default {
  mediaMix: 'Media Mix',
  dataView: 'Data View',
  close: 'Close',
  refresh: 'Refresh',
  saveAsImage: 'Save as Image'
}
